import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "book-section book-lists-section--highlights",
  name: "books",
  tag: "div"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "book-list" }

import { onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useWait } from '@/app/composables/useWait'

import HighlightsCard from '@/app/components/doc/highlights/HighlightsCard.vue'
import HighlightsEmpty from '@/app/components/book/highlights/HighlightsEmpty.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import type { HighlightsAllDoc } from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'HighlightsByBook',
  setup(__props) {

const router = useRouter()
const wait = useWait()

const books = ref<HighlightsAllDoc[]>([])

onBeforeMount(async () => {
  refreshHighlights()
})

async function refreshHighlights(): Promise<void> {
  wait.end('Error Loading Books')
  wait.start('Loading Books')
  try {
    const response = await backend.getHighlightsGrouped()
    books.value = response
  } catch (error: any) {
    wait.start('Error Loading Books')
    Sentry.captureException(error)
  } finally {
    wait.end('Loading Books')
  }
}

function openBook(book: HighlightsAllDoc): void {
  router.push({
    // Note: this works only for books, if we want to show
    // Highlights for other types of content, we need to fix this.
    // https://github.com/shortformhq/main/issues/11389
    name: 'book.highlights',
    params: {
      url_slug: book.url_slug,
    },
  })
}

function isLoadingBooks(): boolean {
  return wait.is('Loading Books')
}

return (_ctx: any,_cache: any) => {
  return (!isLoadingBooks())
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(books.value, (book) => {
              return (_openBlock(), _createBlock(HighlightsCard, {
                key: book.id,
                book: book,
                onUnitClick: ($event: any) => (openBook(book))
              }, null, 8, ["book", "onUnitClick"]))
            }), 128))
          ])
        ]),
        (books.value.length === 0)
          ? (_openBlock(), _createBlock(HighlightsEmpty, { key: 0 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})